// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-content1 {
    width: 800px; /* Increase width */
    max-width: 100%; /* Maximum width */
    height: 80%; /* Increase height */
    max-height: 80%; /* Maximum height */
    overflow-y: auto; /* Enable scrolling for large content */
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.dialog-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}


.dialog-header {
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 10px;
}

.dialog-header h2 {
    margin: 0;
    font-size: 20px;
    color: #333;
}

.dialog-body {
    margin: 20px 0;
}

.dialog-body select {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.dialog-body pre {
    background: #f9f9f9;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
}

.dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn-primary {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-primary:hover {
    background-color: #0056b3;
}
.log-table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 16px;
    text-align: left;
}

.log-table th, .log-table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.log-table th {
    background-color: #f4f4f4;
    font-weight: bold;
}

.log-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.log-table tr:hover {
    background-color: #f1f1f1;
}

.dialog-header h2 {
    font-size: 20px;
    color: #fff;
    margin-bottom: 10px;
}

.dialog-actions {
    margin-top: 20px;
    text-align: right;
}

.btn-primary {
    background-color: #6c63ff;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-primary:hover {
    background-color: #554fcf;
}
.edit_log_title{
    font-size: 20px;
    font-weight:bold;
    margin-top:15px;

}`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/CustomDialogForEditLogs.css"],"names":[],"mappings":"AAAA;IACI,YAAY,EAAE,mBAAmB;IACjC,eAAe,EAAE,kBAAkB;IACnC,WAAW,EAAE,oBAAoB;IACjC,eAAe,EAAE,mBAAmB;IACpC,gBAAgB,EAAE,uCAAuC;IACzD,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;AACjB;;;AAGA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;;AAEnB","sourcesContent":[".dialog-content1 {\n    width: 800px; /* Increase width */\n    max-width: 100%; /* Maximum width */\n    height: 80%; /* Increase height */\n    max-height: 80%; /* Maximum height */\n    overflow-y: auto; /* Enable scrolling for large content */\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n.dialog-overlay {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n\n.dialog-header {\n    border-bottom: 1px solid #eaeaea;\n    margin-bottom: 10px;\n}\n\n.dialog-header h2 {\n    margin: 0;\n    font-size: 20px;\n    color: #333;\n}\n\n.dialog-body {\n    margin: 20px 0;\n}\n\n.dialog-body select {\n    width: 100%;\n    padding: 10px;\n    margin-top: 5px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n}\n\n.dialog-body pre {\n    background: #f9f9f9;\n    padding: 10px;\n    border-radius: 4px;\n    overflow-x: auto;\n}\n\n.dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.btn-primary {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.btn-primary:hover {\n    background-color: #0056b3;\n}\n.log-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n    font-size: 16px;\n    text-align: left;\n}\n\n.log-table th, .log-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n.log-table th {\n    background-color: #f4f4f4;\n    font-weight: bold;\n}\n\n.log-table tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n.log-table tr:hover {\n    background-color: #f1f1f1;\n}\n\n.dialog-header h2 {\n    font-size: 20px;\n    color: #fff;\n    margin-bottom: 10px;\n}\n\n.dialog-actions {\n    margin-top: 20px;\n    text-align: right;\n}\n\n.btn-primary {\n    background-color: #6c63ff;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.btn-primary:hover {\n    background-color: #554fcf;\n}\n.edit_log_title{\n    font-size: 20px;\n    font-weight:bold;\n    margin-top:15px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
